export class AskMessageInfoRequest {
  conversationId: string;
  messageId: string;
  like: Like;

  constructor(conversationId: string, messageId: string, like: Like) {
    this.conversationId = conversationId;
    this.messageId = messageId;
    this.like = like;
  }
}

export class HistoryChat {
  title: string;
  historyDate: string;
  conversationId: string;
}

export enum Like {
  DISLIKE = -1,
  DEFAULT = 0,
  LIKE = 1,
}

export enum Language {
  EN = 'EN',
  KO = 'KO',
}

export interface MergeChatObject {
  requestId: string;
  conversationId: string;
  userKey: string;
}

export interface ConversationInfo {
  title: string;
  historyDate: string; // ISO date string, eg: "2025-04-11T03:52:11.197+00:00"
  conversationId: string;
  chatPage: string;
  lastQuestion: string;
  isBookmark: boolean;
  briefingId: string;
  briefingTitle: string;
  updatedDate: string;
  reportId: string;
  other_info?: any;
  docId?: string;
}

export interface HistoryChatResponse {
  currentPage: number;
  totalPage: number;
  totalItems: number;
  userKey: string;
  conversationInfos: ConversationInfo[];
}
